import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { SlMenu, SlClose } from 'react-icons/sl';

const menus = [
  ['임원주주변동', 'shares'],
  ['대량보유', 'massshares'],
  ['보호예수해제', 'freetosell'],
  ['div', ''], // divider
  ['실적변동', 'updown'],
  ['컨센서스', 'consensus'],
  ['재무상태', 'fstatement'],
];

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  // 스크롤 감지하여 배경색 진하게
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 페이지 이동 시 메뉴 닫기
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  const handleNavigate = (path) => {
    navigate(`/${path}`);
    setIsMenuOpen(false);
  };

  const activeStyle = "text-accent font-bold bg-slate-100 rounded-lg";
  const baseStyle = "text-slate-600 hover:text-slate-900 hover:bg-slate-100 rounded-lg transition-all duration-200";

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b border-slate-200 ${
          scrolled || isMenuOpen
            ? 'bg-white/90 backdrop-blur-md shadow-lg'
            : 'bg-white/80 backdrop-blur-sm'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <div className="flex-shrink-0 cursor-pointer" onClick={() => navigate('/')}>
              <span className="text-xl font-black text-slate-900 tracking-tighter">
                STOCKINU
              </span>
            </div>

            {/* Desktop Menu */}
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-2">
                {menus.map(([title, path], idx) => {
                  if (title === 'div') {
                    return <div key={idx} className="h-4 w-px bg-slate-300 mx-2 self-center"></div>;
                  }
                  const isActive = location.pathname.split('/')[1] === path;
                  return (
                    <button
                      key={idx}
                      onClick={() => handleNavigate(path)}
                      className={`px-3 py-2 text-sm ${isActive ? activeStyle : baseStyle}`}
                    >
                      {title}
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Mobile Menu Button */}
            <div className="-mr-2 flex md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="inline-flex items-center justify-center p-2 rounded-md text-slate-500 hover:text-slate-900 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-slate-500 transition-colors"
              >
                <span className="sr-only">Open main menu</span>
                {isMenuOpen ? (
                  <SlClose className="block h-6 w-6" aria-hidden="true" />
                ) : (
                  <SlMenu className="block h-6 w-6" aria-hidden="true" />
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu Panel */}
        <div
          className={`md:hidden transition-all duration-300 ease-in-out overflow-hidden ${
            isMenuOpen ? 'max-h-screen opacity-100 border-b border-slate-200' : 'max-h-0 opacity-0'
          }`}
        >
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white/95 backdrop-blur-md">
            {menus.map(([title, path], idx) => {
              if (title === 'div') {
                 return <hr key={idx} className="border-slate-200 my-2" />;
              }
              const isActive = location.pathname.split('/')[1] === path;
              return (
                <button
                  key={idx}
                  onClick={() => handleNavigate(path)}
                  className={`block w-full text-left px-3 py-3 text-base font-medium rounded-md ${
                    isActive ? 'bg-slate-100 text-slate-900' : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                  }`}
                >
                  {title}
                </button>
              );
            })}
             <div className="pt-4 pb-2 text-center text-xs text-slate-400">
                stockinu.com@gmail.com
             </div>
          </div>
        </div>
      </nav>
      {/* Spacer to prevent content from being hidden behind fixed navbar */}
      <div className="h-16"></div>
    </>
  );
}
